import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { IconWarning } from '../../design/icons';
import './Auth.css';

interface LoginProps {
  onSwitchToRegister: () => void;
}

const Login: React.FC<LoginProps> = ({ onSwitchToRegister }) => {
  const { login, isLoading } = useAuth();
  const [formData, setFormData] = useState({
    emailOrIdentifiant: '',
    password: '',
  });
  const [error, setError] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (error) setError('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    if (!formData.emailOrIdentifiant || !formData.password) {
      setError('Tous les champs sont obligatoires');
      setIsSubmitting(false);
      return;
    }

    try {
      await login(formData.emailOrIdentifiant, formData.password);
    } catch (error: any) {
      setError(error.message || 'Erreur lors de la connexion');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Vérification en cours...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">
            <div className="logo-icon">€</div>
            <h1>TrackMyBalance</h1>
          </div>
          <h2>Connexion</h2>
          <p>Connectez-vous à votre compte pour accéder à vos finances</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && (
            <div className="error-message">
              <span className="error-icon" style={{ display: 'inline-flex' }}>
                <IconWarning size={14} />
              </span>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="emailOrIdentifiant">Email ou identifiant</label>
            <input
              type="text"
              id="emailOrIdentifiant"
              name="emailOrIdentifiant"
              value={formData.emailOrIdentifiant}
              onChange={handleChange}
              placeholder="Votre email ou identifiant"
              disabled={isSubmitting}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Votre mot de passe"
              disabled={isSubmitting}
              required
            />
          </div>

          <button
            type="submit"
            className={`auth-button ${isSubmitting ? 'loading' : ''}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <div className="button-spinner"></div>
                Connexion...
              </>
            ) : (
              'Se connecter'
            )}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Pas encore de compte ?{' '}
            <button 
              type="button" 
              className="link-button"
              onClick={onSwitchToRegister}
              disabled={isSubmitting}
            >
              Créer un compte
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;